export default __webpack_public_path__ + "static/media/lubaantunGrid13.bd9eea7a.webp";